import { Link } from "react-router-dom";
import { ArrowRight, Tag } from "lucide-react";
import { usePublishedPrices } from "../../lib/productPrices";
import { PriceCtas, PriceDetails } from "../product/PriceDetails";
import { QuoteButton } from "../home/CtaButtons";
import { CompareLink } from "./InfoHero";

export const PRICE_CATEGORIES = [
  { key: "kunststof_kozijnen", label: "Kunststof kozijnen", href: "/kunststof-kozijnen", onderwerp: "kunststof-kozijnen" },
  { key: "aluminium_kozijnen", label: "Aluminium kozijnen", href: "/aluminium-kozijnen", onderwerp: "aluminium-kozijnen" },
  { key: "kunststof_schuifpui", label: "Kunststof schuifpui", href: "/kunststof-schuifpui", onderwerp: "kunststof-schuifpui" },
  { key: "aluminium_schuifpui", label: "Aluminium schuifpui", href: "/aluminium-schuifpui", onderwerp: "aluminium-schuifpui" },
  { key: "aluminium_hefschuifpui", label: "Aluminium hefschuifpui", href: "/aluminium-hefschuifpui", onderwerp: "aluminium-hefschuifpui" },
  { key: "kunststof_deur", label: "Kunststof deuren", href: "/kunststof-deuren", onderwerp: "kunststof-deuren" },
  { key: "aluminium_deur", label: "Aluminium deuren", href: "/aluminium-deuren", onderwerp: "aluminium-deuren" },
];

const PublishedCard = ({ c, p }) => (
  <li className="card flex flex-col p-6" data-testid={`kosten-price-${c.key}`}>
    <Link to={c.href} className="text-[17px] font-semibold text-ink hover:text-maas">{c.label}</Link>
    <div className="mt-3 flex-1"><PriceDetails p={p} testid={`kosten-price-${c.key}-details`} /></div>
    <PriceCtas location={`kosten-${c.key}`} onderwerp={c.onderwerp} />
  </li>
);

const OnRequestList = ({ items, all }) => (
  <div className="card p-6 sm:p-7" data-testid="kosten-price-on-request">
    <div className="flex items-start gap-3">
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><Tag className="h-5 w-5" aria-hidden="true" /></span>
      <div>
        <h3 className="text-[18px] font-semibold text-ink">{all ? "Prijs op maat van uw woning" : "Overige producten: persoonlijke prijsindicatie"}</h3>
        <p className="mt-1.5 max-w-2xl text-[15px] leading-relaxed text-slate-600">
          {all ? "Wij publiceren alleen richtprijzen die wij zelf hebben gecontroleerd. Voor deze producten noemen wij daarom (nog) geen standaardbedrag. U ontvangt vrijblijvend een persoonlijke prijsindicatie op basis van uw situatie en eventuele foto's."
            : "Voor deze producten staat nog geen gecontroleerde richtprijs online. U ontvangt vrijblijvend een persoonlijke prijsindicatie."}
        </p>
      </div>
    </div>
    <ul className="mt-5 flex flex-wrap gap-2">
      {items.map((c) => (
        <li key={c.key}><Link to={c.href} className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3.5 py-1.5 text-[14px] font-medium text-ink hover:bg-maas-soft hover:text-maas">{c.label} <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" /></Link></li>
      ))}
    </ul>
    <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-8">
      <QuoteButton location="kosten-on-request" label="Ontvang vrijblijvend een persoonlijke prijsindicatie" />
      <CompareLink location="kosten-on-request" label="Heeft u al een offerte? Vergelijk uw offerte" />
    </div>
  </div>
);

// Alleen door de eigenaar goedgekeurde bedragen (Beheer → Prijzen); anders geen bedrag.
export const PriceGuide = ({ keys }) => {
  const prices = usePublishedPrices();
  const cats = keys ? PRICE_CATEGORIES.filter((c) => keys.includes(c.key)) : PRICE_CATEGORIES;
  const published = cats.filter((c) => prices[c.key]);
  const rest = cats.filter((c) => !prices[c.key]);
  if (!prices.__ready) return <div className="h-40 animate-pulse rounded-2xl bg-slate-100" />;
  return (
    <div className="space-y-6" data-testid="kosten-price-guide">
      {published.length > 0 && (
        <ul className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">{published.map((c) => <PublishedCard key={c.key} c={c} p={prices[c.key]} />)}</ul>
      )}
      {rest.length > 0 && <OnRequestList items={rest} all={!published.length} />}
    </div>
  );
};
